var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chip',{staticClass:"font-weight-medium text--darken-4",class:_vm.textClass,attrs:{"color":_vm.statusColor(),"label":"","small":_vm.small}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v(_vm._s(_vm.statusIcon()))]),_vm._v(_vm._s(_vm.statusText()))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }